// import { HTTP } from './http-common';

import faqTemp from './content/faq'


export default {

  getQuestions() {
    return new Promise((resolve, reject) => {
      resolve(faqTemp.faq)
    })
  },

  getQuestionById(payload) {
    return new Promise((resolve, reject) => {
      let currentQuestion
      const { faq } = faqTemp

      faq.forEach(item => {
        item[[Object.keys(item)]].forEach(itemFaq => {
          const { questions } = itemFaq
          for (let question in questions) {
            if (questions[question].url === payload) {
              currentQuestion = questions[question]
              break
            }
          }
        })
      })

      setTimeout(() => {
        resolve(currentQuestion)
      }, 0)
    })
  },

}



// WEBPACK FOOTER //
// ./src/api/faq.js